var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrenchFlag = function SvgFrenchFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.77.568v18.864c3.914-1.364 6.705-5.076 6.705-9.432 0-4.356-2.79-8.068-6.705-9.432Z",
    fill: "#FF1300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0a9.657 9.657 0 0 0-3.295.568V19.42a9.656 9.656 0 0 0 3.295.568c1.162 0 2.26-.202 3.27-.568V.57A9.565 9.565 0 0 0 10.5 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.525 10a9.977 9.977 0 0 0 6.68 9.432V.568A9.977 9.977 0 0 0 .525 10Z",
    fill: "#004FBB"
  })));
};
export default SvgFrenchFlag;